export const LINHAS_POR_PAGINA = 20;

export function formatarMoeda(valor) {
    if (valor === null || valor === undefined || valor === '') {
        return '-';
    }

    const numero = Number(valor);

    if (!Number.isFinite(numero)) {
        return '-';
    }

    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(numero).replace(/\u00A0/g, ' ');
}

export function buildLinhaRemuneracaoGerente(gerente) {
    const numeroFilial = gerente.idfilial - 10000;
    const filial = gerente.nome_filial
        ? `${numeroFilial} - ${gerente.nome_filial}`
        : String(numeroFilial);

    return {
        idfolhapagamento: gerente.idfolhapagamento,
        nome: gerente.nome,
        filial,
        salariobase: formatarMoeda(gerente.salariobase),
        vendatotal: formatarMoeda(gerente.vendatotal),
        valorcomissaovendatotal: formatarMoeda(gerente.valorcomissaovendatotal),
        juros: formatarMoeda(gerente.juros),
        valorcomissaojuros: formatarMoeda(gerente.valorcomissaojuros),
        saquefacil: formatarMoeda(gerente.saquefacil),
        valorcomissaosaquefacil: formatarMoeda(gerente.valorcomissaosaquefacil),
        valorcomissaototal: formatarMoeda(gerente.valorcomissaototal),
        cluster: gerente.idcluster || '-'
    };
}

export function getColunasRemuneracaoGerentes() {
    return [
        { nome: 'Código', atributo: 'idfolhapagamento', style: { minWidth: '92px', width: '92px' } },
        { nome: 'Nome', atributo: 'nome', style: { minWidth: '280px', width: '280px' } },
        { nome: 'Filial', atributo: 'filial', style: { minWidth: '200px', width: '200px' } },
        { nome: 'Cluster', atributo: 'cluster', style: { minWidth: '150px', width: '150px' } },
        { nome: 'Ação', atributo: 'acao', style: { minWidth: '80px', width: '80px', textAlign: 'center' } }
    ];
}

export function getLinhasPaginadas(rows, page) {
    if (!Array.isArray(rows)) {
        return rows;
    }

    const paginaAtual = Math.max(Number(page) || 1, 1);
    const inicio = (paginaAtual - 1) * LINHAS_POR_PAGINA;

    return rows.slice(inicio, inicio + LINHAS_POR_PAGINA);
}

export function getTotalPaginas(rows) {
    if (!Array.isArray(rows) || rows.length === 0) {
        return 1;
    }

    return Math.ceil(rows.length / LINHAS_POR_PAGINA);
}
